import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {SessionActions} from "../../../shared/actions/session.actions";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {Stocktaking} from "../../model/stocktaking";
import {FormControl} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {StocktakingService} from "../../services/stocktaking/stocktaking.service";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {DatePipe} from "@angular/common";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {FileService} from "../../../core/visbos-core/http/file.service";

@Component({
  selector: 'vb-stocktakings-list',
  templateUrl: './stocktakings-list.component.html',
  styleUrls: ['./stocktakings-list.component.css']
})
export class StocktakingsListComponent extends AbstractListView implements OnInit, OnChanges {

  @ViewChild('stocktakingsTable')
  stocktakingsTable: DatatableComponent;

  @ViewChild('typeTmpl')
  typeTmpl: TemplateRef<any>;

  @Input()
  stocktakingsList: Stocktaking[] = [];

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private stocktakingService: StocktakingService,
              private fileService: FileService,
              private datePipe: DatePipe,
              private router: Router, private route: ActivatedRoute) {
    super(sessionActions, cd);

    this.columns = [];

  }


  ngOnInit(): void {
    super.ngOnInit();

    this.columns = [
      {name: 'Inventurart', flexGrow: 2, cellTemplate: this.typeTmpl},
      {prop: 'created_at', name: 'Inventurbeginn', flexGrow: 1, cellTemplate: this.stocktakingsTable.formatDateTmpl},
      {
        prop: 'reporting_date',
        name: 'Inventurstichtag',
        flexGrow: 1,
        cellTemplate: this.stocktakingsTable.formatDateTmpl
      },
      {prop: 'description', name: 'Bezeichner', flexGrow: 3},
      {prop: 'responsible_user.label', name: 'Verantwortlich', flexGrow: 2},
    ];

    this.searchTerm = new FormControl();

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.stocktakingsList) {
      this.rows = this.stocktakingsList || [];
    }
  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.stocktakingsList;
    } else {
      if (this.stocktakingsList) {
        this.rows = this.stocktakingsList.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onCellUpdate(row, res, index) {
  }

  rowFormat(row) {

    let cls = {};

    cls['pinned-down'] = row.is_sealed;
    cls['deactivated'] = row.is_sealed;

    return cls;
  }

  onEditStocktakingClicked(stocktaking: Stocktaking) {
    this.router.navigate(['./', stocktaking.cuid], {relativeTo: this.route});
  }

  onDeleteStocktakingClicked(stocktaking: Stocktaking) {
    this.stocktakingService.deleteStocktaking(stocktaking.cuid).toPromise()
      .then(res => this.sessionActions.pushMessage("Inventur erfolgreich gelöscht!", MessageType.SUCCESS, "Inventur"))
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Löschen der Inventur!"));
  }

  onGenerateStocktakingReportPDFClicked(stocktaking: Stocktaking) {
    this.sessionActions.pushMessage("Die PDF-Datei wird generiert, dies kann einen Moment dauern...", MessageType.INFO, "Inventur");
    this.stocktakingService.generateStocktakingReportPDF(stocktaking.cuid).toPromise()
      .then(res => {
        let data = this.fileService.base64toBlob(res.data.stocktakingReportPdf, 'application/pdf', 512);
        this.fileService.saveAs(data, 'inventurbericht.pdf');
      })

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stocktaking/stocktakings-list/stocktakings-list.component.ts